import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {PaymentMethodsRequestBoyd} from "app/types/service-types/PaymentMethodsTypes";
import {PaymentMethodsService} from 'app/services';
import {toggleQuickPanel} from "app/main/shared-components/quick-panel/store";
import {fetchAllPaymentMethods} from "./paymentmethods-list.slice";
import {errorMsg, successMsg} from "app/utils/MessageUtils";

interface CreatePaymentMethodStateParams {
  body: PaymentMethodsRequestBoyd;
  onSuccess?: Function;
  onError?: Function;
}

export const createPaymentMethod = (params: CreatePaymentMethodStateParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await PaymentMethodsService.createPaymentMethod(params.body);
    if (response.status === 201) {
      dispatch(setSuccess(true));
      dispatch(toggleQuickPanel());
      dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Payment method successfully added!' : 'Metoda për pagesë u shtua me sukses!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
      // @ts-ignore
      dispatch(fetchAllPaymentMethods());
    }
    dispatch(setLoading(false));
  } catch (err) {
    dispatch(setLoading(false));
    dispatch(errorMsg(err.data.message));
    if (params.onError) params.onError();
    dispatch(setError(err.data.message));
  }
}

interface CreatePaymentMethodsSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: CreatePaymentMethodsSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'configurations/payment-methods',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setSuccess: (state, action) => {
      state.success = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;